/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { 
  FiRefreshCw, 
  FiSearch, 
  FiFilter, 
  FiGrid,
  FiList,
  FiUsers,
  FiMessageCircle,
  FiClock,
  FiCheckCircle,
  FiXCircle,
  FiAlertCircle,
  FiUser,
  FiCalendar,
  FiTag,
  FiTrendingUp,
  FiTrendingDown,
  FiEye,
  FiEdit2,
  FiTrash2,
  FiPlus,
  FiArrowUp,
  FiArrowDown,
  FiBarChart2,
  FiAward,
  FiStar,
  FiFileText,
  FiMessageSquare,
  FiHash,
  FiSettings
} from "react-icons/fi";
import { 
  MdOutlineForum, 
  MdOutlineCategory,
  MdOutlinePerson,
  MdOutlineCalendarToday,
  MdOutlineCheckCircle,
  MdOutlineCancel,
  MdOutlinePending,
  MdOutlineRefresh,
  MdOutlineSearch,
  MdOutlineFilter,
  MdOutlineChat,
  MdOutlineComment,
  MdOutlineVisibility,
  MdOutlineEdit,
  MdOutlineDelete,
  MdOutlineAdd,
  MdOutlinePeople
} from "react-icons/md";
import { IoChatbubbleEllipsesOutline, IoPeopleOutline, IoTimeOutline } from "react-icons/io5";
import CommunityTable from "./Table/CommunityTable";
import { useDispatch, useSelector } from "react-redux";
import {
  actionByAdminOnCommunityUserForm,
  deletecommunityPost,
  getAllCommunityList,
} from "../../Redux/communitySlice";
import CommunityView from "./Modal/CommunityView";
import Loader from "../../components/Loader/Loader";
import SimpleDeleteModal from "../../components/Delete Modal/SimpleDeleteModal";
import { useNavigate } from "react-router";
import ConfirmToggleModal from "./Modal/ConfirmToggleModal";
import { toast } from "react-toastify";

const CommunityMangment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selector = useSelector((state) => state);
  const {
    communitySlice: { community = [], loading, totalCommunity = null },
  } = selector ? selector : {};
  const [isSessionModal, setIsSessionModal] = useState(false);
  const [isSessionModalData] = useState(null);
  const [offset, setIsoffset] = useState(0);
  const [size] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const [keyWord, setKeyword] = useState("");
  const [active, setactive] = useState("");
  const [isConfirmDelete, setIsConfirmDelete] = useState(false);
  const [reportCount, setreportCount] = useState("all");
  const [formType, setFormType] = useState("");

  const [Id] = useState("");
  const [Id2, setId2] = useState("");
  const [adminToggleData, setAdminToggleData] = useState({
    isOpen: false,
    data: null,
  });
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);

  const [sortKey, setSortKey] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  const handleSort = (key) => {
    if (sortKey === key) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortKey(key);
      setSortOrder("asc");
    }
    setPageNo(1);
  };

  const TbaleHeader = [
    { label: "#", sortKey: null },
    { label: "Discussion Agenda", sortKey: "title" },
    { label: "Post Type", sortKey: "form_type" },
    { label: "Expert", sortKey: "user.fullName" },
    { label: " Total Comment", sortKey: "totalComment" },
    { label: "Admin Status", sortKey: "isDisableByAdmin" },
    { label: "Created  Date", sortKey: "createdAt" },
    { label: "Action", sortKey: null },
  ];

  let apiBodyData = {
    pageNo: pageNo,
    size: size,
    keyWord: keyWord,
    reportCount: reportCount,
    sortKey: sortKey,
    sortOrder: sortOrder,
  };

  useEffect(() => {
    if (active !== "") {
      Object.assign(apiBodyData, {
        reportCount: reportCount,
      });
    }

    Object.assign(apiBodyData, { form_type: formType });

    dispatch(getAllCommunityList(apiBodyData));
  }, [keyWord, active, reportCount, formType, isRefresh, sortKey, sortOrder, pageNo, size]);

  const viewAction = (data) => {
    navigate(`/app/community/${data?._id}`);
  };
  const toggleSessionModal = () => {
    setIsSessionModal(!isSessionModal);
    dispatch(getAllCommunityList(apiBodyData));
  };

  const handlePageClick = (data) => {
    const newPageNo = data.selected + 1;
    let offset = Math.ceil(data.selected * size);
    setIsoffset(offset);
    setPageNo(newPageNo);
    let params = {
      pageNo: newPageNo,
      size: size,
      keyWord: keyWord,
      reportCount: reportCount,
      form_type: formType,
      sortKey: sortKey,
      sortOrder: sortOrder,
    };
    dispatch(getAllCommunityList(params));
  };

  const handleKeywordChange = (e) => {
    setKeyword(e.target.value);
  };

  const toggleModal = () => {
    setIsConfirmDelete(false);
  };

  const handleSubmitDelete = async () => {
    await dispatch(deletecommunityPost({ commentId: Id }));
    toggleModal();
    toggleSessionModal();
  };

  const handleViewUser = (data) => {
    console.log(data);
    setIsSessionModal(!isSessionModal);
    setId2(data?._id);
  };

  const handleConfirmToggle = async () => {
    try {
      setIsActionLoading(true);
      const response = await dispatch(
        actionByAdminOnCommunityUserForm({
          id: adminToggleData?.data?.id,
          isDisableByAdmin: adminToggleData?.data?.isDisableByAdmin,
        }),
      );

      if (response?.payload?.code === 200) {
        toast.success("Status updated successfully");
      } else {
        toast.error(response?.payload?.message || "Failed to update status.");
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error?.message || "Oops! Something went wrong. Please try again.",
      );
    } finally {
      setIsActionLoading(false);
      setAdminToggleData({ isOpen: false, data: null });
      setIsRefresh(!isRefresh);
    }
  };

  const handleAdminToggle = async () => {
    try {
      
    } catch (error) {
      
    }
  }

  // Calculate statistics
  const totalDiscussions = totalCommunity || community?.length || 0;
  const activeDiscussions = community?.filter(c => !c?.isDisableByAdmin)?.length || 0;
  const inactiveDiscussions = community?.filter(c => c?.isDisableByAdmin)?.length || 0;
  const totalComments = community?.reduce((sum, c) => sum + (c?.totalComment || 0), 0) || 0;

  // Stats cards data
  const statsCards = [
    {
      title: 'Total Discussions',
      count: totalDiscussions,
      icon: MdOutlineForum,
      color: 'from-blue-500 to-blue-600',
      subtitle: 'All forum posts'
    },
    // {
    //   title: 'Active',
    //   count: activeDiscussions,
    //   icon: MdOutlineCheckCircle,
    //   color: 'from-emerald-500 to-emerald-600',
    //   subtitle: 'Active discussions'
    // },
    // {
    //   title: 'Inactive',
    //   count: inactiveDiscussions,
    //   icon: MdOutlineCancel,
    //   color: 'from-rose-500 to-rose-600',
    //   subtitle: 'Inactive discussions'
    // },
    // {
    //   title: 'Total Comments',
    //   count: totalComments,
    //   icon: MdOutlineComment,
    //   color: 'from-purple-500 to-purple-600',
    //   subtitle: 'All comments'
    // }
  ];

  return (
    <div className="min-h-screen bg-gray-50/80">
      <Loader loading={loading || isActionLoading} />

      {/* Header Banner */}
      <div className="bg-gradient-to-r from-[#855DF6] via-[#7B5CF6] to-[#715EFE] shadow-lg relative overflow-hidden">
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20 animate-pulse"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-12 -mb-12 animate-pulse"></div>
        <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
        
        <div className="relative z-10 px-4 md:px-7 py-6 md:py-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="p-2.5 bg-white/20 rounded-xl backdrop-blur-sm shadow-lg">
                <MdOutlineForum className="w-5 h-5 text-white md:w-6 md:h-6" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-white md:text-2xl dahboardFont tracking-tight">
                  Community Forum Management
                </h2>
                <p className="text-sm text-white/70 hidden sm:block">
                  Manage discussions and community posts
                </p>
              </div>
            </div>
            {/* <div className="flex items-center gap-2">
              <div className="flex items-center gap-2 px-3 py-1.5 bg-white/20 rounded-full backdrop-blur-sm">
                <FiRefreshCw className="w-3.5 h-3.5 text-white/70" />
                <span className="text-xs text-white/80">
                  {new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                </span>
              </div>
            </div> */}
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-2 gap-3 mt-5 sm:grid-cols-4 md:gap-4">
            {statsCards.map((card, index) => (
              <div 
                key={index}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300 group"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-lg font-bold text-white uppercase md:text-lg">
                      {card.title}
                    </p>
                    <p className="text-xl font-bold text-white md:text-2xl mt-0.5">
                      {card.count}
                    </p>
                    {card.subtitle && (
                      <p className="text-[10px] text-white/40 hidden sm:block">
                        {card.subtitle}
                      </p>
                    )}
                  </div>
                  <div className={`p-2 rounded-xl bg-gradient-to-br ${card.color} bg-opacity-30 shadow-inner`}>
                    <card.icon className="w-4 h-4 text-white md:w-5 md:h-5" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <section className="px-3 py-4 -mt-4 md:px-6 lg:px-10 md:py-6">
        <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
          <div className="p-3 md:p-4">
            <CommunityTable
              setreportCount={setreportCount}
              TbaleName={`Discussions (${totalCommunity})`}
              TbaleHeader={TbaleHeader}
              TbaleData={community}
              viewAction={viewAction}
              setactive={setactive}
              offset={offset}
              size={size}
              total={totalCommunity}
              handlePageClick={handlePageClick}
              keyWord={keyWord}
              handleOnChange={handleKeywordChange}
              handleViewUser={handleViewUser}
              formType={formType}
              setFormType={setFormType}
              setAdminToggleData={setAdminToggleData}
              currentSortKey={sortKey}
              currentSortOrder={sortOrder}
              onSort={handleSort}
              toggleAdminAction={handleConfirmToggle}
            />
          </div>
        </div>
      </section>

      {/* Modals */}
      {isSessionModal && (
        <CommunityView
          onCancel={toggleSessionModal}
          inputValue={isSessionModalData}
          Id2={Id2}
        />
      )}

      {isConfirmDelete && (
        <SimpleDeleteModal
          isOpen={isConfirmDelete}
          title={`Delete`}
          description={`Are You sure to delete this comment?`}
          onCancel={toggleModal}
          onDelete={handleSubmitDelete}
        />
      )}
      
      {adminToggleData.isOpen && (
        <ConfirmToggleModal
          isOpen={adminToggleData.isOpen}
          isDisable={adminToggleData.data.isDisableByAdmin}
          onCancel={() => setAdminToggleData({ isOpen: false, data: null })}
          onConfirm={handleConfirmToggle}
        />
      )}
    </div>
  );
};

export default CommunityMangment;